import { action } from "mobx";
import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { useQueryClient } from "react-query";
import styled from "styled-components";
import { useLocStore } from "../../../../wsLocalization";
import { LocContext } from "../../../../wsLocalization/LocContext";
import { useLatestQuery } from "../../../../WSUtils/useLatestQuery";
import { UserInfoContext } from "../../../../WSUtils/UserInfoContext";
import { useStore, useStore2 } from "../../../../WSUtils/useStore";
import { concatClassnames } from "../../../../WSUtils/util";
import { WSFormGrid } from "../../../../WSUtils/WSFormGrid";
import { sentryAssertData } from "../../../../WSUtils/wsSentry";
import { CVEditContext } from "../../CVEditContext";
import { CVEditBaseField } from "../../Fields/CVEditBaseField";
import { CVEditLanguageList } from "./CVEditLanguageList";
import { CVEditLanguageSegmentStore } from "./CVEditLanguageSegmentStore";

export const CVEditLanguageSegment = observer(() => {
  const L = useLocStore(LocContext.CV);
  const userInfo = useContext(UserInfoContext);

  const languageSegmentStore = useStore2(
    "CVEditLanguageSegmentStore",
    (dt) =>
      new CVEditLanguageSegmentStore({
        name: "CVEditLanguageSegmentStore",

        parentDt: dt,
        useHooks: (t: CVEditLanguageSegmentStore) => {
          t.userInfo = useContext(UserInfoContext);
          t.queryClient = useQueryClient();
          t.cvEditContext = useContext(CVEditContext);
        },
      })
  );

  const { data: knowledge } = useLatestQuery(
    ["candidateAPI.getKnowledgeForCandidate"],
    () =>
      userInfo.fullAPI.candidateAPI.getKnowledgeForCandidate({
        userInfo,
      })
  );

  const { data: allKnowledgeTypes } = useLatestQuery(
    ["typesAPI.getTypes(kunnskap)"],
    () =>
      userInfo.fullAPI.typesAPI.getTypes({
        userInfo,
        group: "kunnskap",
        excludeFolderName: false,
      })
  );

  sentryAssertData([allKnowledgeTypes, knowledge], { userInfo });

  // put react-query data in mobx state
  useEffect(
    action(() => {
      languageSegmentStore.allKnowledgeTypes = allKnowledgeTypes;
    }),
    [allKnowledgeTypes]
  );

  return (
    <CVEditLanguageSegmentStyles className="cve-language-segment cve-segment">
      <div className="cvp-h2 cve-header">
        {L.id("baa9708f3dcd").loc("Språk")}
      </div>

      <CVEditLanguageList
        onChange={languageSegmentStore.onChange}
        languageSegmentStore={languageSegmentStore}
      />

      <WSFormGrid
        float
        className={concatClassnames([
          "cve-button-bar",
          languageSegmentStore.showPlaceholder && "cve-button-bar-placeholder",
        ])}
      >
        <CVEditBaseField
          def={languageSegmentStore.languageField}
          renderOnlyComponent
        />
      </WSFormGrid>
    </CVEditLanguageSegmentStyles>
  );
});

const CVEditLanguageSegmentStyles = styled(WSFormGrid)``;
